import styled from "@emotion/styled";
import { size } from "@stedi/dls/constants";

const SNoScript = styled.noscript({
  width: "640px",
  margin: "0 auto",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: "100vh",
  fontSize: size.s4,
});

export const NoScript = () => <SNoScript>You need to enable JavaScript to use JSONata Playground</SNoScript>;
